<script setup>
import {onMounted, ref, watch} from 'vue'
import {codePreview, formatDate} from '@/helper';
import {Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'
import DocumentTemplateService from "@/services/DocumentTemplateService";
import Select from "@/components/forms/Select.vue";
import {useI18n} from 'vue-i18n';

const {t} = useI18n()
const groupedTemplates = ref([]);
const availableTemplates = ref([])
const selectedTemplates = ref([]);

const isOpen = ref(true)
const emit = defineEmits(['confirm', 'cancel']);
const closeModalWith = (value) => {
  console.log(selectedTemplates.value)
  isOpen.value = false;
  setTimeout(() => {
    if (value === 'confirm') {
      emit('confirm', {templateIds: selectedTemplates.value.map(template => template.value)});
    } else {
      emit('cancel');
    }
  }, 300);
}

function openModal() {
  isOpen.value = true
}

function addToSelected(groupIndex, templateIndex) {
  if (templateIndex === null) {
    availableTemplates.value[groupIndex].templates.forEach(template => {
      if (!selectedTemplates.value.find(selected => selected.value === template.value)) {
        selectedTemplates.value.push(template);
      }
    });

  } else {
    const template = availableTemplates.value[groupIndex].templates[templateIndex];
    if (!selectedTemplates.value.find(selected => selected.value === template.value)) {
      selectedTemplates.value.push(template);
    }
  }
}

function removeFromSelected(value) {
  selectedTemplates.value = selectedTemplates.value.filter(template => template.value !== value);
  // refresh available templates
  availableTemplates.value = {...groupedTemplates.value};

}

onMounted(() => {
  DocumentTemplateService.getAllCategorized('select').then(response => {
    groupedTemplates.value = response;
    availableTemplates.value = response;
  });
})
</script>

<template>
  <TransitionRoot appear :show="isOpen" as="template">
    <Dialog as="div"  class="modal show d-block" style="z-index: 1055;">
      <div class="modal-backdrop fade show"></div>
      <div class="modal-dialog modal-dialog-centered modal-lg" style="z-index: 1055">
        <div class="modal-content flex">
          <DialogPanel class="modal-body p-4 rounded-lg shadow-lg">
            <div class="d-flex">
              <div class="w-50 border-1 border-secondary-subtle border-end pe-2">
                <DialogTitle as="h5" class="modal-title">{{ t('generateDocumentModal.available_templates') }}</DialogTitle>
                <div style="height: 200px; max-height: 200px; overflow-y: auto;">
                <table class="table table-hover">
                  <template v-for="(group, groupIndex) in availableTemplates" :key="groupIndex">
                    <thead>
                    <tr>
                      <th>
                        <span class="mdi mdi-format-list-group"></span>
                        {{group.name}}
                      </th>
                      <th class="text-end">
                        <button class="btn btn-link" @click="addToSelected(groupIndex, null)">
                          <span class="mdi mdi-plus-circle"></span>
                        </button>
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(template, templateIndex) in group.templates" :key="templateIndex+'-'+template.value">
                      <td class="ps-4">
                        <span class="mdi mdi-file-document-outline"></span>
                        {{template.label}}
                      </td>
                      <td class="text-end">
                        <button class="btn btn-link" @click="addToSelected(groupIndex, templateIndex)">
                          <span class="mdi mdi-plus-circle"></span>
                        </button>
                      </td>
                    </tr>
                    </tbody>
                  </template>
                </table>
                </div>
              </div>
              <div class="w-50 ps-2">
                <DialogTitle as="h5" class="modal-title">{{ t('generateDocumentModal.selected_templates') }}</DialogTitle>
                <div style="height: 200px; max-height: 200px; overflow-y: auto;">
                <table class="table table-hover">
                  <tbody>
                  <tr v-for="(template) in selectedTemplates" :key="'selected'+template.value">
                    <td class="">
                      <span class="mdi mdi-file-document-outline"></span>
                      {{template.label}}
                    </td>
                    <td class="text-end">
                      <button class="btn btn-link" @click="removeFromSelected(template.value)">
                        <span class="mdi mdi-minus-circle"></span>
                      </button>
                    </td>
                  </tr>
                  </tbody>
                </table>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-link text-decoration-underline text-dark" @click="closeModalWith('cancel')">{{ t('generateDocumentModal.cancel') }}</button>
              <button class="btn btn-primary btn-sm" @click="closeModalWith('confirm')" :disabled="!selectedTemplates">{{ t('generateDocumentModal.generate') }}</button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

